import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CLINIC } from "@/lib/clinicInfo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("nehchal_admin_token", data.token);
      localStorage.setItem("nehchal_admin_email", data.email);
      toast.success("Signed in");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Seo title="Admin Login" description="Nehchal Eye Centre admin panel" path="/admin" noindex />
      <div className="min-h-screen bg-secondary/40 flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 shadow-sm" data-testid="admin-login-card">
          <div className="flex items-center gap-3 mb-6">
            <img src={CLINIC.logo} alt="Nehchal Eye Centre" className="h-12 w-auto object-contain" />
            <div className="leading-tight border-l border-border pl-3">
              <div className="font-serif text-base text-primary">Nehchal Eye Centre</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-foreground/60">Admin Panel</div>
            </div>
          </div>
          <h1 className="font-serif text-2xl mb-6">Sign in</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-wider text-muted-foreground">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5"
                data-testid="admin-login-email"
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-muted-foreground">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5"
                data-testid="admin-login-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex justify-center items-center rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm hover:bg-primary/90 disabled:opacity-60"
              data-testid="admin-login-submit"
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
